import React, { useContext } from "react";
import { Box, Container, Grid, Link, Typography } from "@mui/material";
import ConfigContext from "../context/ConfigContext";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import { getOptimizedCloudinaryUrl } from "../util";
import StoreLocation from "./StoreLocation";
import moment from "moment";
import { Link as RouterLink } from "react-router-dom";

export default function Footer(props) {
  const siteConfig = useContext(ConfigContext);

  //const staticMapUrl = getStaticMapUrl(siteConfig.stores);

  return (
    <Box component="footer" pt={10} sx={{ backgroundColor: "#303651", color: "#fff" }}>
      <Container maxWidth="md">
        <Box mb={2}>
          <Box>
            <Grid container spacing={2} justifyContent={"center"}>
              {siteConfig.stores.map((store, idx) => (
                <Grid item xs={12} sm={6} key={idx}>
                  <StoreLocation key={idx} store={store} index={idx} />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
        {/*siteConfig.footer?.map && (
          <Box
            mt={6}
            sx={{
              width: "100%",
              "& iframe": {
                width: "100%",
                height: "auto",
                aspectRatio: "16/9",
              },
            }}
            dangerouslySetInnerHTML={{
              __html: decodeURIComponent(siteConfig.footer.map).replace(
                /<iframe\s/gi,
                `<iframe tabindex="-1" title="Google Map showing store location of ${siteConfig.biz}" `
              ),
            }}
          ></Box>
        )*/}

        <Box textAlign={"center"}>
          <Box py={2}>
            {siteConfig.ig && (
              <Link
                aria-label="Our Instagram page"
                color="inherit"
                style={{ padding: ".5rem" }}
                href={siteConfig.ig}
                underline="hover"
              >
                <InstagramIcon />
              </Link>
            )}
            {siteConfig.fb && (
              <Link
                aria-label="Our Facebook page"
                color="inherit"
                style={{ padding: ".5rem" }}
                href={siteConfig.fb}
                underline="hover"
              >
                <FacebookIcon />
              </Link>
            )}
          </Box>
        </Box>
      </Container>
      <Box mt={6} px={4}>
        <Box
          py={4}
          sx={{
            display: "flex",
            gap: "2rem",
            alignItems: "center",
            justifyContent: "space-between",
            borderTop: "1px solid #999",
            flexWrap: "nowrap",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              gap: "2rem",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Link
              component={RouterLink}
              underline="none"
              to={"/store-policy"}
              style={{ color: "inherit", cursor: "pointer" }}
            >
              Store Policy
            </Link>
            <Link
              component={"a"}
              href="https://bakestreet.co/terms-of-service"
              underline="none"
              sx={{ color: "inherit" }}
            >
              Terms of Use
            </Link>
            <Link
              component={"a"}
              href="https://bakestreet.co/privacy-policy"
              underline="none"
              sx={{ color: "inherit" }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              underline="none"
              to={"/accessibility"}
              style={{ color: "inherit", cursor: "pointer" }}
            >
              Accessibility
            </Link>
          </Box>
          <Box
            sx={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0 }}
          >
            <Link
              aria-label="BakeStreet's website"
              component={"a"}
              href="https://bakestreet.co"
              underline="none"
              sx={{ color: "inherit" }}
            >
              <img
                src={getOptimizedCloudinaryUrl(
                  `https://res.cloudinary.com/draqf7k7f/image/upload/f_auto,q_80,w_150/v1751065038/powered-outline_vnxicq.png`,
                  "f_auto,q_auto"
                )}
                alt="Powered by BakeStreet"
                loading="lazy"
                style={{ height: "25px" }}
              />
            </Link>
            <Typography
              variant="caption"
              display="block"
              sx={{ textAlign: "center", whiteSpace: "nowrap" }}
            >
              &copy; {moment().format("YYYY")} BakeStreet Inc.
            </Typography>
            <Box>
              <Typography variant="caption">{process.env.REACT_APP_VERSION}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
